export const PaymentOverlayButton = {
  PayBtn: 'pay-btn',
} as const;
